module.exports = __webpack_public_path__ + "static/img/proplist-can.e3902d6.png";